import "./App.css";
import RandomQuote from "./RandomQuote";
function App() {
  return (
    <body className="app">
      <div className="container">
        <h1>Star Wars quotes</h1>
        <RandomQuote />;
      </div>
    </body>
  );
}
export default App;
